import React, { useState, useEffect } from "react";
import { GenGet, GenPost } from "state/api";
import MsgAlert from "Admin/components/MsgAlert";
import ErrorState from "Admin/components/ErrorState";
import SubmitButton from "Admin/components//SubmitButton";
import LoadingState from "Admin/components/LoadingState";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import Venda from "../Vendas/Venda";
import VerVenda from "../Vendas/VerVenda";

const NovoCaixa = ({setRefresh}) =>{
    const [msg, setMsg] = useState(null);
    const [posting, setPosting] = useState(false);
    const [formData, setFormData] = useState({
        'valor_abertura':0,
        'observacoes':'',
    });


    const handleSubmit = async () => {
        if (!formData.valor_abertura){
            setMsg('O campo "Valor de Abertura" é obrigatório')
            setTimeout(() => setMsg(null), 3000)
        }
        try {
            setPosting(true)
            const response = await GenPost('/novocaixa', formData);
            
            setMsg(response.message);
            setTimeout(() => setMsg(null), 3000);
            setRefresh(true)
            setPosting(false)
            setFormData({});
        
        } catch (err) {
            setMsg(err.message);
            setTimeout(() => setMsg(null), 3000);
            setPosting(false)
        }
    };

    const handleFieldChange = (e) => {
        if (e.target.type === "checkbox") {
          setFormData({ ...formData, [e.target.name]: e.target.checked ? 1 : 0 });
          return;
        }
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    return(
        <div className="flex flex-col ">
            <p className="text-[12pt] font-semibold">Novo Caixa</p>
            <div className="flex md:flex-row flex-col justify-between m-2">
                <div className="flex flex-col gap-1 w-full md:w-[calc(49%-2rem)]">
                    <label className="font-semibold">
                        Valor de Abertura
                        <span className="text-red-500"> *</span>
                    </label>
                    <input
                        type={'number'}
                        name={'valor_abertura'}
                        value={formData.valor_abertura || ""}
                        min={'0'}
                        onChange={handleFieldChange}
                        className="px-2 py-1 rounded border border-gray-300 focus:outline-none"
                    />
                </div>
                <div className="flex flex-col gap-1 w-full md:w-[calc(49%-2rem)]">
                    <label className="font-semibold">
                        Observações
                    </label>
                    <textarea
                        name={'observacoes'}
                        rows={4}
                        value={formData.observacoes || ""}
                        onChange={handleFieldChange}
                        className="px-2 py-1 rounded border border-gray-300 focus:outline-none"
                    />
                </div>

            </div>
            <SubmitButton loading={posting} onClick={handleSubmit} label="Abrir Caixa"/>
            <MsgAlert alert={msg} />    
        </div>
    );
}

const CaixaAberto = ({caixa, setRefresh}) =>{
    const [msg, setMsg] = useState(null);
    const [vendaModalOpen, setVendaModalOpen] = useState(false);
    const [vendaPointer, setVendaPointer] = useState(null);
    const [detalheVendaModalOpen, setDetalheVendaModalOpen] = useState(false);
    const [fechamentoModalOpen, setFechamentoModalOpen] = useState(false);
    const [formaPagamento, setFormaPagamento] = useState('');
    const [postingFechamento, setPostingFechamento] = useState(false);
    const totalAtual = caixa.vendas.map((item) => parseInt(item.total)).reduce((total, item) => total + item, 0).toFixed(2)

    const handleDetalhes = (id) => {
        setVendaPointer(id);
        setDetalheVendaModalOpen(true);
    }

    const handleExcluirVenda = async (id) => {
        if (!window.confirm('Tem certeza que deseja excluir esta venda?')) {
            return;
        }

        try {
            const response = await GenPost(`/deletevenda/${id}`);
            setMsg(response.message || 'Venda excluída com sucesso');
            setTimeout(() => setMsg(null), 3000);
            setRefresh(true);
        } catch (err) {
            setMsg(err.message || 'Erro ao excluir venda');
            setTimeout(() => setMsg(null), 3000);
        }
    }

    const handleCloseVenda = () => {
        setVendaModalOpen(false);
        setRefresh(true)
        console.log('refresh')
    }

    const handleFecharCaixa = async () => {
        if (!formaPagamento) {
            setMsg('Preencha a Forma de Pagamento.');
            setTimeout(() => setMsg(null), 3000);
            return;
        }
        setPostingFechamento(true);
        try {
            const response = await GenPost(`/fecharcaixa/${caixa.id}`, { forma_pagamento: formaPagamento });
            setMsg('Caixa fechado com sucesso!');
            setFechamentoModalOpen(false);
            setFormaPagamento('');
            setRefresh(true);
        } catch (err) {
            setMsg(err.message || 'Erro ao fechar caixa');
        } finally {
            setPostingFechamento(false);
            setTimeout(() => setMsg(null), 3000);
        }
    };

    return (
        <div className="flex flex-col relative">
            <div className="flex gap-2 absolute top-4 right-4">
            <button 
                className=" bg-blue-400 flex justify-center items-center align-middle hover:bg-blue-500 rounded-lg admin-button" 
                onClick={() => setVendaModalOpen(true)}
            >
                Nova Venda
            </button>
            <button 
                className=" bg-green-400 flex justify-center items-center align-middle hover:bg-green-500 rounded-lg admin-button" 
                onClick={() => setFechamentoModalOpen(true)}
            >
                Fechar Caixa
            </button>
            </div>

            {caixa && (
                <div className="flex flex-col overflow-y-hidden h-[60vh]">
                    <h2 className="text-[12pt] font-semibold p-0 m-0">Informações do Caixa Atual</h2>
                    <p className="text-[10pt] font-semibold p-0 ml-2 my-0">Código: {caixa.id}</p>
                    <p className="text-[10pt] font-semibold p-0 ml-2 my-0">Data de Abertura: {caixa.data_abertura}</p>
                    <p className="text-[10pt] font-semibold p-0 ml-2 my-0">Valor de Abertura: {caixa.valor_abertura}</p>
                    <p className="text-[10pt] font-semibold p-0 ml-2 my-0">Responsável pela Abertura: {caixa.responsavel_abertura}</p>
                    <br/>
                    
                    <h3 className="text-[12pt] font-semibold p-0 m-0">Vendas</h3>
                    <br/>

                    <ul className="flex gap-1 flex-col overflow-y-scroll h-full">
                        {caixa.vendas.map(venda => (
                            <li className="flex gap-2 p-2 border rounded-md" key={venda.id}>
                                <p  className="text-[10pt] h-full font-semibold p-0 my-0">ID Venda: {venda.id}</p>
                                <p className="text-[10pt] h-full font-semibold p-0 my-0"> - Cliente ID: {venda.cliente_id}</p>
                                <p className="text-[10pt] h-full font-semibold p-0 my-0"> - Total: {venda.total}</p>
                                <p className="text-[10pt] h-full font-semibold p-0 my-0"> - Modo de Pagamento: {venda.modo_pagamento}</p>
                                <div className="flex gap-2 justify-end flex-grow">
                                    <button className="bg-blue-400 flex justify-center items-center align-middle hover:bg-blue-500 px-2 rounded-sm text-[9pt] text-slate-50" onClick={() => handleDetalhes(venda.id)}>Detalhes</button>
                                    <button className="bg-red-400 flex justify-center items-center align-middle hover:bg-red-500 px-2 rounded-sm text-[9pt] text-slate-50" onClick={() => handleExcluirVenda(venda.id)}>Excluir</button>
                                </div>
                            </li>
                        ))}
                    </ul>

                    <p className="text-[12pt] font-semibold p-0 ml-2 mt-2">Total Atual: R${totalAtual}</p>
                </div>
            )}

            {/* Modal de Nova Venda */}
            <Dialog 
                open={vendaModalOpen} 
                onClose={() => handleCloseVenda()} 
                PaperProps={{
                    style: {
                        width: '80vw',
                        height: '95vh',
                        maxWidth: 'none', 
                        maxHeight: 'none',
                    }
                }}
            >
                <DialogContent>
                    <Venda
                        onSuccess={() => {
                            setVendaModalOpen(false);
                        }}
                    />
                </DialogContent>
            </Dialog>
            <Dialog 
                open={fechamentoModalOpen} 
                onClose={() => setFechamentoModalOpen(false)} 
                PaperProps={{
                    style: {
                        width: '50vw',
                        height: '60vh',
                        maxWidth: 'none', 
                        maxHeight: 'none',
                    }
                }}
            >
                <DialogContent>
                    <div className="flex flex-col justify-center align-middle items-center h-full p-4 relative text-center">
                        <p className="text-[9pt] text-slate-700">Deseja fechar o caixa atual? <br/>Atenção após essa operação ele não poderá ser aberto novamente.</p>
                        <TextField
                            label="Forma de Pagamento"
                            value={formaPagamento}
                            onChange={e => setFormaPagamento(e.target.value)}
                            fullWidth
                            margin="normal"
                        />
                        <div className="flex justify-between gap-1 absolute bottom-0">
                            <button className="bg-red-400 flex justify-center items-center align-middle hover:bg-red-500 px-2 rounded-sm admin-button" onClick={() => setFechamentoModalOpen(false)}>Cancelar</button>
                            <button className="bg-blue-400 flex justify-center items-center align-middle hover:bg-blue-500 px-2 rounded-sm admin-button" onClick={() => handleFecharCaixa()}>Confirmar</button>
                        </div>
                        
                    </div>
                </DialogContent>
            </Dialog>

            <Dialog 
                open={detalheVendaModalOpen && vendaPointer} 
                onClose={() => setDetalheVendaModalOpen(false)} 
                PaperProps={{
                    style: {
                        width: '80vw',
                        height: '90vh',
                        maxWidth: 'none', 
                        maxHeight: 'none',
                    }
                }}
            >
                <DialogContent>
                    <VerVenda id={vendaPointer} />
                </DialogContent>
            </Dialog>

            <MsgAlert alert={msg} />    
        </div>
    );

}

function CaixaAtual() {
  const [msg, setMsg] = useState(null);
  const [error, seError] = useState(null);
  const [novoCaixa, setNovoCaixa] = useState(false);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({})
  const [refresh, setRefresh] = useState(false);

  const fetchData = async (endpoint, setter) => {
    try {
      const response = await GenGet(endpoint);
      console.log(response)
      setNovoCaixa(false)
      setter(response)

    } catch (err) {

        if (err.response.status === 404) {
            setNovoCaixa(true)
        
        } else {
             seError(true);   
        }      
    }
  };

  useEffect(() => {
    Promise.all([
        fetchData('/caixaatual', setData),
    ]).then(() => setLoading(false)); 

  }, []);

  useEffect(() => {
    if(refresh){
        console.log('innerstate')
        setLoading(true)
        Promise.all([
            fetchData('/caixaatual', setData),
        ]).then(() => setLoading(false)); 
    }
  }, [refresh]);

  if (loading) {
    return (
      <LoadingState />
    )
  }

  if (error) {
    return (
      <ErrorState />
    )
  }

  return (
    <div className="p-2 flex flex-col ">
        { novoCaixa ? (
            <NovoCaixa setRefresh={setRefresh}/>
        ) : (
            <CaixaAberto caixa={data} setRefresh={setRefresh}/>
        )

        }
        <MsgAlert alert={msg} />    
    </div>
  )
}

export default CaixaAtual